import React, { useContext } from 'react';
import { Button, Progress } from 'antd';
import './styles.less';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import steps from '../../../steps';
import { EnrollmentContext } from '../../../../../providers/EnrollmentContextProvider';

const EnrollmentProgressCircle = ({ onBack }) => {
  const { currentStep, currentStepIndex } = useContext(EnrollmentContext);
  const fixedCurrentStepIndex = Math.min(currentStepIndex, steps.length - 2);
  const percent = Math.min(
    Math.ceil((100 * (fixedCurrentStepIndex + 1)) / (steps.length - 1 || 1)),
    99.999
  );

  return (
    <div className="enrollment-progress">
      {fixedCurrentStepIndex > 0 && currentStepIndex < steps.length - 1 && (
        <Button type="link" className="enrollment-progress-back-button" onClick={onBack}>
          <ArrowLeftOutlined />
        </Button>
      )}
      <Progress
        className="enrollment-progress__indicator"
        type="circle"
        percent={percent}
        format={() => `${fixedCurrentStepIndex + 1} de ${steps.length - 1}`}
        width={57}
      />
      <div className="enrollment-progress__text">
        <h2 className="enrollment-progress__title">{currentStep.title}</h2>
        <p className="enrollment-progress__description">{currentStep.description}</p>
      </div>
    </div>
  );
};

EnrollmentProgressCircle.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default EnrollmentProgressCircle;
